import { request } from 'utils/request';

const globalApi = {
  getAllSeasons: (envId: number) => {
    return request({
      url: `hiiko_environment/${envId}/seasons`,
    });
  },
};

export default globalApi;
